import { addMinutes } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'

import { countDecimals } from '@common/functions'
import { IDate, IDutchAuction } from '@types'

export const getMintPrice = (mintPrice: string, startDate: IDate, dutchAuction: IDutchAuction | undefined): string => {
    const dateZone = () => utcToZonedTime(new Date().toISOString(), 'America/Mexico_City')
    if (dutchAuction) {
        const startDateAsDefaultFormat = new Date(
            startDate.year,
            startDate.month - 1,
            startDate.day,
            startDate.hour,
            startDate.minute,
            startDate.second,
        )

        const oneSecond = 1000
        const oneMinuteInSeconds = 60
        const lastDecresseDate = addMinutes(
            new Date(startDateAsDefaultFormat),
            dutchAuction.numDecreases * dutchAuction.decreaseInterval,
        )
        const decreasseInteravalInSeconds = dutchAuction.decreaseInterval * oneMinuteInSeconds
        const lastDecreaseDurationInMS = Math.max(lastDecresseDate.getTime() - dateZone().getTime(), 0)
        const remainingDecresses = Math.ceil(lastDecreaseDurationInMS / oneSecond / decreasseInteravalInSeconds)
        const mintPriceDecrease = (dutchAuction.numDecreases - remainingDecresses) * dutchAuction.decreaseSize
        const mintPriceCalculated = Number(mintPrice) - Math.max(mintPriceDecrease, 0)
        mintPrice = mintPriceCalculated.toFixed(countDecimals(mintPriceCalculated))
    }

    return mintPrice
}
